// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/admin_feature_stats.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import type { Date } from "../google/type/date_pb";
import { file_google_type_date } from "../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/admin_feature_stats.proto.
 */
export const file_v1_admin_feature_stats: GenFile = /*@__PURE__*/
  fileDesc("Chx2MS9hZG1pbl9mZWF0dXJlX3N0YXRzLnByb3RvEgJ2MSJWCh1HZXRGZWF0dXJlVXNhZ2VTdW1tYXJ5UmVxdWVzdBIPCgdmZWF0dXJlGAEgASgJEhIKCnN0YXJ0X2RhdGUYAiABKAkSEAoIZW5kX2RhdGUYAyABKAkitQEKHkdldEZlYXR1cmVVc2FnZVN1bW1hcnlSZXNwb25zZRJJCgxldmVudF9jb3VudHMYASADKAsyMy52MS5HZXRGZWF0dXJlVXNhZ2VTdW1tYXJ5UmVzcG9uc2UuRXZlbnRDb3VudHNFbnRyeRIUCgxhY3RpdmVfdXNlcnMYAiABKAMaMgoQRXZlbnRDb3VudHNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAM6AjgBIlQKG0dldEZlYXR1cmVVc2FnZURhaWx5UmVxdWVzdBIPCgdmZWF0dXJlGAEgASgJEhIKCnN0YXJ0X2RhdGUYAiABKAkSEAoIZW5kX2RhdGUYAyABKAkisgEKFkZlYXR1cmVVc2FnZURhaWx5UG9pbnQSCwoDZGF5GAEgASgJEkEKDGV2ZW50X2NvdW50cxgCIAMoCzIrLnYxLkZlYXR1cmVVc2FnZURhaWx5UG9pbnQuRXZlbnRDb3VudHNFbnRyeRIUCgxhY3RpdmVfdXNlcnMYAyABKAMaMgoQRXZlbnRDb3VudHNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAM6AjgBIkoKHEdldEZlYXR1cmVVc2FnZURhaWx5UmVzcG9uc2USKgoGcG9pbnRzGAEgAygLMhoudjEuRmVhdHVyZVVzYWdlRGFpbHlQb2ludCLJAQocR2V0RmVhdHVyZVVzYWdlQnlVc2VyUmVxdWVzdBIPCgdmZWF0dXJlGAEgASgJEhIKCnN0YXJ0X2RhdGUYAiABKAkSEAoIZW5kX2RhdGUYAyABKAkSDAoEcGFnZRgEIAEoBRIRCglwYWdlX3NpemUYBSABKAUSKgoHc29ydF9ieRgGIAEoDjIZLnYxLkZlYXR1cmVVc2FnZVNvcnRGaWVsZBISCgpzb3J0X2V2ZW50GAcgASgJEhEKCXNvcnRfZGVzYxgIIAEoCCLWAQoTRmVhdHVyZVVzYWdlVXNlclJvdxIQCgh1c2VybmFtZRgBIAEoCRI+CgxldmVudF9jb3VudHMYAiADKAsyKC52MS5GZWF0dXJlVXNhZ2VVc2VyUm93LkV2ZW50Q291bnRzRW50cnkSEwoLZGF5c19hY3RpdmUYAyABKAUSJAoJbGFzdF91c2VkGAQgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZRoyChBFdmVudENvdW50c0VudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoAzoCOAEiWwodR2V0RmVhdHVyZVVzYWdlQnlVc2VyUmVzcG9uc2USJQoEcm93cxgBIAMoCzIXLnYxLkZlYXR1cmVVc2FnZVVzZXJSb3cSEwoLdG90YWxfY291bnQYAiABKAMq3gEKFUZlYXR1cmVVc2FnZVNvcnRGaWVsZBIoCiRGRUFUVVJFX1VTQUdFX1NPUlRfRklFTERfVU5TUEVDSUZJRUQQABIiCh5GRUFUVVJFX1VTQUdFX1NPUlRfRklFTERfRVZFTlQQARIlCiFGRUFUVVJFX1VTQUdFX1NPUlRfRklFTERfVVNFUk5BTUUQAhIoCiRGRUFUVVJFX1VTQUdFX1NPUlRfRklFTERfREFZU19BQ1RJVkUQAxImCiJGRUFUVVJFX1VTQUdFX1NPUlRfRklFTERfTEFTVF9VU0VEEAQyuQMKGEFkbWluRmVhdHVyZVN0YXRzU2VydmljZRKLAQoWR2V0RmVhdHVyZVVzYWdlU3VtbWFyeRIhLnYxLkdldEZlYXR1cmVVc2FnZVN1bW1hcnlSZXF1ZXN0GiIudjEuR2V0RmVhdHVyZVVzYWdlU3VtbWFyeVJlc3BvbnNlIiqC0+STAiQ6ASoiHy92MS9hZG1pbi9mZWF0dXJlLXN0YXRzL3N1bW1hcnkSgwEKFEdldEZlYXR1cmVVc2FnZURhaWx5Eh8udjEuR2V0RmVhdHVyZVVzYWdlRGFpbHlSZXF1ZXN0GiAudjEuR2V0RmVhdHVyZVVzYWdlRGFpbHlSZXNwb25zZSIogtPkkwIiOgEqIh0vdjEvYWRtaW4vZmVhdHVyZS1zdGF0cy9kYWlseRKIAQoVR2V0RmVhdHVyZVVzYWdlQnlVc2VyEiAudjEuR2V0RmVhdHVyZVVzYWdlQnlVc2VyUmVxdWVzdBohLnYxLkdldEZlYXR1cmVVc2FnZUJ5VXNlclJlc3BvbnNlIiqC0+STAiQ6ASoiHy92MS9hZG1pbi9mZWF0dXJlLXN0YXRzL2J5LXVzZXJCKFomZ2l0aHViLmNvbS9kdWNidC90dC1nby9nZW4vcHJvdG8vdjE7djFiBnByb3RvMw", [file_google_api_annotations, file_google_type_date]);

/**
 * Requests the summary of one feature over a date range.
 *
 * @generated from message v1.GetFeatureUsageSummaryRequest
 */
export type GetFeatureUsageSummaryRequest = Message<"v1.GetFeatureUsageSummaryRequest"> & {
  /**
   * Feature key, for example "bet_limit".
   *
   * @generated from field: string feature = 1;
   */
  feature: string;

  /**
   * First day of the range, YYYY-MM-DD, Vietnam date, inclusive.
   *
   * @generated from field: string start_date = 2;
   */
  startDate: string;

  /**
   * Last day of the range, YYYY-MM-DD, Vietnam date, inclusive.
   *
   * @generated from field: string end_date = 3;
   */
  endDate: string;
};

/**
 * Describes the message v1.GetFeatureUsageSummaryRequest.
 * Use `create(GetFeatureUsageSummaryRequestSchema)` to create a new message.
 */
export const GetFeatureUsageSummaryRequestSchema: GenMessage<GetFeatureUsageSummaryRequest> = /*@__PURE__*/
  messageDesc(file_v1_admin_feature_stats, 0);

/**
 * Totals of one feature over the requested range.
 *
 * @generated from message v1.GetFeatureUsageSummaryResponse
 */
export type GetFeatureUsageSummaryResponse = Message<"v1.GetFeatureUsageSummaryResponse"> & {
  /**
   * Total count per event, for example page_view and copy.
   *
   * @generated from field: map<string, int64> event_counts = 1;
   */
  eventCounts: { [key: string]: bigint };

  /**
   * Distinct users with any usage in the range.
   *
   * @generated from field: int64 active_users = 2;
   */
  activeUsers: bigint;
};

/**
 * Describes the message v1.GetFeatureUsageSummaryResponse.
 * Use `create(GetFeatureUsageSummaryResponseSchema)` to create a new message.
 */
export const GetFeatureUsageSummaryResponseSchema: GenMessage<GetFeatureUsageSummaryResponse> = /*@__PURE__*/
  messageDesc(file_v1_admin_feature_stats, 1);

/**
 * Requests the per-day figures of one feature over a date range.
 *
 * @generated from message v1.GetFeatureUsageDailyRequest
 */
export type GetFeatureUsageDailyRequest = Message<"v1.GetFeatureUsageDailyRequest"> & {
  /**
   * Feature key, for example "bet_limit".
   *
   * @generated from field: string feature = 1;
   */
  feature: string;

  /**
   * First day of the range, YYYY-MM-DD, Vietnam date, inclusive.
   *
   * @generated from field: string start_date = 2;
   */
  startDate: string;

  /**
   * Last day of the range, YYYY-MM-DD, Vietnam date, inclusive.
   *
   * @generated from field: string end_date = 3;
   */
  endDate: string;
};

/**
 * Describes the message v1.GetFeatureUsageDailyRequest.
 * Use `create(GetFeatureUsageDailyRequestSchema)` to create a new message.
 */
export const GetFeatureUsageDailyRequestSchema: GenMessage<GetFeatureUsageDailyRequest> = /*@__PURE__*/
  messageDesc(file_v1_admin_feature_stats, 2);

/**
 * One day of usage.
 *
 * @generated from message v1.FeatureUsageDailyPoint
 */
export type FeatureUsageDailyPoint = Message<"v1.FeatureUsageDailyPoint"> & {
  /**
   * The day, YYYY-MM-DD.
   *
   * @generated from field: string day = 1;
   */
  day: string;

  /**
   * Total count per event on that day.
   *
   * @generated from field: map<string, int64> event_counts = 2;
   */
  eventCounts: { [key: string]: bigint };

  /**
   * Distinct users with any usage on that day.
   *
   * @generated from field: int64 active_users = 3;
   */
  activeUsers: bigint;
};

/**
 * Describes the message v1.FeatureUsageDailyPoint.
 * Use `create(FeatureUsageDailyPointSchema)` to create a new message.
 */
export const FeatureUsageDailyPointSchema: GenMessage<FeatureUsageDailyPoint> = /*@__PURE__*/
  messageDesc(file_v1_admin_feature_stats, 3);

/**
 * Per-day usage of one feature.
 *
 * @generated from message v1.GetFeatureUsageDailyResponse
 */
export type GetFeatureUsageDailyResponse = Message<"v1.GetFeatureUsageDailyResponse"> & {
  /**
   * One point per day in the range, oldest first, zero-filled.
   *
   * @generated from field: repeated v1.FeatureUsageDailyPoint points = 1;
   */
  points: FeatureUsageDailyPoint[];
};

/**
 * Describes the message v1.GetFeatureUsageDailyResponse.
 * Use `create(GetFeatureUsageDailyResponseSchema)` to create a new message.
 */
export const GetFeatureUsageDailyResponseSchema: GenMessage<GetFeatureUsageDailyResponse> = /*@__PURE__*/
  messageDesc(file_v1_admin_feature_stats, 4);

/**
 * Requests a page of per-user usage of one feature.
 *
 * @generated from message v1.GetFeatureUsageByUserRequest
 */
export type GetFeatureUsageByUserRequest = Message<"v1.GetFeatureUsageByUserRequest"> & {
  /**
   * Feature key, for example "bet_limit".
   *
   * @generated from field: string feature = 1;
   */
  feature: string;

  /**
   * First day of the range, YYYY-MM-DD, Vietnam date, inclusive.
   *
   * @generated from field: string start_date = 2;
   */
  startDate: string;

  /**
   * Last day of the range, YYYY-MM-DD, Vietnam date, inclusive.
   *
   * @generated from field: string end_date = 3;
   */
  endDate: string;

  /**
   * 1-based page number; values below 1 mean 1.
   *
   * @generated from field: int32 page = 4;
   */
  page: number;

  /**
   * Rows per page; default 50, maximum 200.
   *
   * @generated from field: int32 page_size = 5;
   */
  pageSize: number;

  /**
   * Column to sort by.
   *
   * @generated from field: v1.FeatureUsageSortField sort_by = 6;
   */
  sortBy: FeatureUsageSortField;

  /**
   * Event to sort by when sort_by is EVENT; default "page_view".
   *
   * @generated from field: string sort_event = 7;
   */
  sortEvent: string;

  /**
   * Sorts descending when true.
   *
   * @generated from field: bool sort_desc = 8;
   */
  sortDesc: boolean;
};

/**
 * Describes the message v1.GetFeatureUsageByUserRequest.
 * Use `create(GetFeatureUsageByUserRequestSchema)` to create a new message.
 */
export const GetFeatureUsageByUserRequestSchema: GenMessage<GetFeatureUsageByUserRequest> = /*@__PURE__*/
  messageDesc(file_v1_admin_feature_stats, 5);

/**
 * One user's usage of a feature.
 *
 * @generated from message v1.FeatureUsageUserRow
 */
export type FeatureUsageUserRow = Message<"v1.FeatureUsageUserRow"> & {
  /**
   * The user's username.
   *
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * Total count per event in the range.
   *
   * @generated from field: map<string, int64> event_counts = 2;
   */
  eventCounts: { [key: string]: bigint };

  /**
   * Distinct dates with usage in the range.
   *
   * @generated from field: int32 days_active = 3;
   */
  daysActive: number;

  /**
   * Last date with usage in the range.
   *
   * @generated from field: google.type.Date last_used = 4;
   */
  lastUsed?: Date;
};

/**
 * Describes the message v1.FeatureUsageUserRow.
 * Use `create(FeatureUsageUserRowSchema)` to create a new message.
 */
export const FeatureUsageUserRowSchema: GenMessage<FeatureUsageUserRow> = /*@__PURE__*/
  messageDesc(file_v1_admin_feature_stats, 6);

/**
 * A page of per-user usage.
 *
 * @generated from message v1.GetFeatureUsageByUserResponse
 */
export type GetFeatureUsageByUserResponse = Message<"v1.GetFeatureUsageByUserResponse"> & {
  /**
   * The users of the requested page.
   *
   * @generated from field: repeated v1.FeatureUsageUserRow rows = 1;
   */
  rows: FeatureUsageUserRow[];

  /**
   * Users with usage in the range, across all pages.
   *
   * @generated from field: int64 total_count = 2;
   */
  totalCount: bigint;
};

/**
 * Describes the message v1.GetFeatureUsageByUserResponse.
 * Use `create(GetFeatureUsageByUserResponseSchema)` to create a new message.
 */
export const GetFeatureUsageByUserResponseSchema: GenMessage<GetFeatureUsageByUserResponse> = /*@__PURE__*/
  messageDesc(file_v1_admin_feature_stats, 7);

/**
 * Column the per-user list is sorted by.
 *
 * @generated from enum v1.FeatureUsageSortField
 */
export enum FeatureUsageSortField {
  /**
   * Treated as EVENT.
   *
   * @generated from enum value: FEATURE_USAGE_SORT_FIELD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * By the count of the event named in sort_event.
   *
   * @generated from enum value: FEATURE_USAGE_SORT_FIELD_EVENT = 1;
   */
  EVENT = 1,

  /**
   * By username.
   *
   * @generated from enum value: FEATURE_USAGE_SORT_FIELD_USERNAME = 2;
   */
  USERNAME = 2,

  /**
   * By the number of days with usage.
   *
   * @generated from enum value: FEATURE_USAGE_SORT_FIELD_DAYS_ACTIVE = 3;
   */
  DAYS_ACTIVE = 3,

  /**
   * By the last day with usage.
   *
   * @generated from enum value: FEATURE_USAGE_SORT_FIELD_LAST_USED = 4;
   */
  LAST_USED = 4,
}

/**
 * Describes the enum v1.FeatureUsageSortField.
 */
export const FeatureUsageSortFieldSchema: GenEnum<FeatureUsageSortField> = /*@__PURE__*/
  enumDesc(file_v1_admin_feature_stats, 0);

/**
 * AdminFeatureStatsService reports how a beta feature is used, read from the
 * daily usage rollup. Admin role only.
 *
 * @generated from service v1.AdminFeatureStatsService
 */
export const AdminFeatureStatsService: GenService<{
  /**
   * Total count of each event, and the number of distinct active users, in a date range.
   *
   * @generated from rpc v1.AdminFeatureStatsService.GetFeatureUsageSummary
   */
  getFeatureUsageSummary: {
    methodKind: "unary";
    input: typeof GetFeatureUsageSummaryRequestSchema;
    output: typeof GetFeatureUsageSummaryResponseSchema;
  },
  /**
   * Event counts and active users for every day in a date range, zero-filled.
   *
   * @generated from rpc v1.AdminFeatureStatsService.GetFeatureUsageDaily
   */
  getFeatureUsageDaily: {
    methodKind: "unary";
    input: typeof GetFeatureUsageDailyRequestSchema;
    output: typeof GetFeatureUsageDailyResponseSchema;
  },
  /**
   * A page of users with their event counts, active days and last use in a date range.
   *
   * @generated from rpc v1.AdminFeatureStatsService.GetFeatureUsageByUser
   */
  getFeatureUsageByUser: {
    methodKind: "unary";
    input: typeof GetFeatureUsageByUserRequestSchema;
    output: typeof GetFeatureUsageByUserResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_admin_feature_stats, 0);

